<template>
  <div class="h-screen flex items-center justify-center" :class="isDark ? 'bg-zinc-950' : 'bg-gray-50'">
    <div class="text-center space-y-4 max-w-md px-4">
      <!-- Debug info visible -->
      <div class="mb-4 text-xs" :class="isDark ? 'text-zinc-600' : 'text-gray-400'">
        <p>🔍 GoogleCallbackView chargé</p>
        <p>URL: {{ currentUrl }}</p>
      </div>

      <div v-if="loading" class="space-y-4">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 mx-auto"
          :class="isDark ? 'border-white' : 'border-amber-600'"></div>
        <p class="text-sm" :class="isDark ? 'text-zinc-400' : 'text-gray-600'">
          Authentification avec Google en cours...
        </p>
        <p class="text-xs" :class="isDark ? 'text-zinc-500' : 'text-gray-500'">
          Vérification de votre compte...
        </p>
      </div>

      <div v-if="error" class="space-y-4">
        <div class="text-red-500">
          <svg class="w-12 h-12 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <p class="text-sm font-medium">{{ error }}</p>
        </div>
        <button @click="redirectToLogin"
          class="px-6 py-2 rounded-xl text-sm font-medium"
          :class="isDark
            ? 'bg-white text-black hover:bg-gray-200'
            : 'bg-amber-600 text-white hover:bg-amber-700'">
          Retour à la connexion
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useTheme } from '@/composables/useTheme'
import { useApi } from '@/composables/useApi'

export default {
  setup() {
    const { isDark } = useTheme()
    const { fetchApi } = useApi()
    return { isDark, fetchApi }
  },
  data() {
    return {
      loading: true,
      error: null,
      currentUrl: window.location.href
    }
  },
  async mounted() {
    console.log('🚀 [GoogleCallbackView] Component mounted')
    console.log('🔍 [GoogleCallbackView] Current URL:', window.location.href)
    console.log('🔍 [GoogleCallbackView] Route params:', this.$route.params)
    console.log('🔍 [GoogleCallbackView] Route query:', this.$route.query)
    await this.handleGoogleCallback()
  },
  methods: {
    async handleGoogleCallback() {
      console.log('\n========================================')
      console.log('🔵 [FRONTEND] Traitement callback Google')
      console.log('========================================\n')

      try {
        // Récupérer le code d'autorisation depuis l'URL
        const urlParams = new URLSearchParams(window.location.search)
        const code = urlParams.get('code')
        const errorParam = urlParams.get('error')

        console.log('1️⃣ [GoogleCallback] Paramètres URL récupérés:')
        console.log('   - Code:', code ? `${code.substring(0, 20)}...` : 'AUCUN CODE')
        console.log('   - Error:', errorParam || 'Aucune erreur')

        if (errorParam) {
          console.error('❌ [GoogleCallback] Erreur retournée par Google:', errorParam)
          this.error = 'Authentification annulée ou refusée'
          this.loading = false
          return
        }

        if (!code) {
          console.error('❌ [GoogleCallback] CODE MANQUANT dans l\'URL')
          console.error('   URL complète:', window.location.href)
          this.error = 'Code d\'autorisation manquant'
          this.loading = false
          return
        }

        console.log('2️⃣ [GoogleCallback] Envoi du code au backend...')
        console.log('   - Endpoint: /api/clients/google/callback')
        console.log('   - Method: POST')

        // Envoyer le code au backend pour validation
        const response = await this.fetchApi('/api/clients/google/callback', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ code })
        })

        console.log('3️⃣ [GoogleCallback] Réponse backend reçue')
        console.log('   - Status:', response.status)
        console.log('   - OK:', response.ok)

        const data = await response.json()
        console.log('   - Data:', data)

        if (!response.ok) {
          console.error('❌ [GoogleCallback] Erreur backend:', data.message)
          throw new Error(data.message || 'Erreur lors de l\'authentification')
        }

        console.log('4️⃣ [GoogleCallback] Stockage du token...')
        // Stocker le token dans le localStorage
        localStorage.setItem('clientToken', data.token)

        // Définir l'expiration du token (4 heures)
        const expireTime = Date.now() + 4 * 60 * 60 * 1000
        localStorage.setItem('clientToken_expire', expireTime.toString())

        // Stocker l'ID utilisateur si fourni (backend renvoie 'client' et non 'user')
        if (data.client && data.client._id) {
          localStorage.setItem('USERID', data.client._id)
          console.log('   - User ID stocké:', data.client._id)
        }

        console.log('\n╔════════════════════════════════════════╗')
        console.log('║ ✅ AUTHENTIFICATION GOOGLE RÉUSSIE    ║')
        console.log('╚════════════════════════════════════════╝')
        console.log('👤 Email:', data.client?.email)
        console.log('🎫 Token stocké dans localStorage')
        console.log('🆔 User ID:', data.client?._id)
        console.log('════════════════════════════════════════\n')

        // Rediriger avec un refresh complet pour que App.vue détecte la connexion
        const redirectPath = this.$route.query.redirect || '/'
        console.log('5️⃣ [GoogleCallback] Redirection vers:', redirectPath)

        // Petite attente pour s'assurer que localStorage est bien synchronisé
        setTimeout(() => {
          console.log('🔄 [GoogleCallback] Redirection en cours...')
          window.location.href = redirectPath
        }, 500)

      } catch (error) {
        console.error('\n❌❌❌ [GoogleCallback] ERREUR ❌❌❌')
        console.error('Type:', error.name)
        console.error('Message:', error.message)
        console.error('Stack:', error.stack)
        console.error('════════════════════════════════════════\n')

        this.error = error.message || 'Erreur lors de l\'authentification avec Google'
        this.loading = false
      }
    },
    redirectToLogin() {
      this.$router.push('/signup')
    }
  }
}
</script>
